import React from 'react';
import { Title } from '../components/ui/Title';

function TermsAndConditions() {
  return (
    <div className="container mx-auto px-6 py-8 md:py-24">
      <Title>Terms and Conditions</Title>
      
      <div className="max-w-3xl mx-auto panel">     
        <h2 className="text-2xl font-semibold mb-6">Responsibility</h2>
        
        <div className="space-y-6 text-light/80">
          <p>
            By accessing and using this website, you agree to the following terms and conditions. If you do not agree with these terms, please do not use this website.
          </p>

          <h3 className="text-xl font-semibold mt-8 mb-4">Use of the Platform</h3>
          <p>
            You may use this website for lawful purposes only. You must not use this website in any way that may damage the site, impair its availability, or interfere with other users' access.
          </p>
          
          <h3 className="text-xl font-semibold mt-8 mb-4">User-Generated Content</h3>
          <p>
            If you post, upload, or otherwise submit content to this website (such as comments, text, images, or other media), you are solely responsible for that content.
You agree that your content will not:
          </p>
          <ul className="list-disc pl-6 space-y-2">
            <li>
              Violate any law or the rights of third parties,
            </li>
            <li>
Contain defamatory, offensive, or harmful material,
            </li>
            <li>
Include spam, viruses, or malicious software.
            </li>
          </ul>
          <p>
  You grant the website operator a non-exclusive, royalty-free, worldwide license to use, display, and reproduce your content as part of the website. The operator reserves the right to remove or block any content at any time without notice.
          </p>        
          
          <h3 className="text-xl font-semibold mt-8 mb-4">Intellectual Property</h3>
          <p>
            All content on this site, unless otherwise stated, is the property of the website operator and protected by copyright laws. Unauthorized use, reproduction, or distribution of content is prohibited.
          </p>

          <h3 className="text-xl font-semibold mt-8 mb-4">Liability</h3>
          <p>
            We strive to provide accurate and up-to-date information, but we do not guarantee the completeness, accuracy, or reliability of the content. Use of the website is at your own risk. We are not liable for any damages arising from the use or inability to use the website or its content.
          </p>

          <h3 className="text-xl font-semibold mt-8 mb-4">External Links</h3>
          <p>
            This website may contain links to third-party websites. We are not responsible for the content or policies of those external sites.
          </p>

          <h3 className="text-xl font-semibold mt-8 mb-4">Modifications</h3>
          <p>
            We reserve the right to update or change these terms at any time. Continued use of the website after changes are posted constitutes acceptance of those changes.
          </p>

          <h3 className="text-xl font-semibold mt-8 mb-4">Governing Law</h3>
          <p>
            These terms are governed by the laws of Switzerland. Any disputes shall be resolved in the competent courts of Switzerland.
          </p>
        </div>
      </div>
    </div>
  );
}

export default TermsAndConditions;